<template>
  <div class="case">
    <div class="banner-wrapper">
      <img src="../assets/home/case-banner.png" alt="" class="banner">
    </div>
    <div class="case-wrapper">
      <div class="project">
        <h3 class="departmental-title">
          <span>项目介绍</span>
        </h3>
        <p class="project-discribe">
          为进一步加强北京银川两地教育合作，促进首都教育精准帮扶转型升级，助力宁夏“互联网+教育”示范区建设，深化“首都教育远程互助工程”，京银两地启动“首都带首府”“互联网+教育”首师大双优云桥项目。双优云桥主推“互联网+研修”，泛在培训理念，构建多端融合的研修环境，实现碎片化学习效果。平台集结了近百名学术大家、大学教授、特高级一线名师，共建一套教师研修能力体系。同时面向教师、学生、教学研究者（专家）、助教、管理者五大群体提供可视化的研修信息发布系统，可视化的学习成果系统、可视化的数据驱动决策系统，便于对项目的管办评多元维度进行统筹。
        </p>
        <ul class="project-ul flex-between">
          <li v-for="(item,index) in projectMainList" :key="index" class="project-li">
            <h4 class="project-li-title flex-align">
              <img :src="item.icon" alt="">
              {{item.title}}
            </h4>
            <div class="project-li-introduce flex-align">
              <p>{{item.introduce}}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="news">
        <h3 class="departmental-title">
          <span>媒体报道</span>
        </h3>
        <ul class="news-ul">
          <li class="news-li csp" v-for="(item,index) in newsList" :key="index" :class="{'new-li-one':index == 0}">
            <p class="news-li-type" v-if="index!=0">{{item.type}}</p>
            <img src="../assets/home/new1.png" alt="" class="news-li-img">
            <div class="news-li-one-cover" v-if="index==0">
              <span class="news-li-type">{{item.type}}</span>
              <h5 class="news-li-title wes-2">{{item.title}}</h5>
              <p class="news-li-time">{{item.time}}</p>
            </div>
            <div class="news-li-info" v-if="index!=0">
              <h5 class="news-li-title wes-2">{{item.title}}</h5>
              <p class="news-li-time">{{item.time}}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="expert">
        <h3 class="departmental-title">
          <span>专家团队</span>
        </h3>
        <div class="part-inner expert-inner wrapper">
          <el-carousel indicator-position="none" arrow="always" :autoplay="false" class="expert-carousel">
            <el-carousel-item v-for="(item,index) in expertList" :key="index">
              <div class="expert-ul flex-between">
                <div class="expert-item" v-for="(each,index) in item" :key="index">
                  <div class="expert-item-inner">
                    <div><img :src="each.image" alt="" class="expert-avatar"></div>
                    <div class="expert-item-info">
                      <p class="expert-name">{{each.name}}</p>
                      <p class="expert-introduce wes-3">{{each.instruction}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        projectMainList: [{
            icon: require("../assets/home/icon1.png"),
            title: '研训一体',
            introduce: '研：教研，解决课堂教学中存在疑难问题，以课堂问题解决为指向。\n训：培训，促进教师专业素养提高，以专业发展为指向。学习、研究、实践融为一体'
          },
          {
            icon: require("../assets/home/icon2.png"),
            title: '成果共享',
            introduce: '支持研训一体的成果在不同学校、不同教师间共享使用，助力更大范围教师专业成长。'
          },
          {
            icon: require("../assets/home/icon3.png"),
            title: '数据支持',
            introduce: '全过程、伴随式数据采集，实时精准全面数据分析，图表化显示研训情况，以数据引导教师按需学习，助力区域科学管理。'
          }
        ],
        pages: { //分页
          currentPage: 1,
          pageSize: 3,
          total: 0,
        },
        expertList: [],
        newsList: [{
            id: 1,
            title: '2021年十四师“首都教育远程互助工程” 教育教学能力提升项目',
            time: '2021年10月18日',
            type: '新闻资讯'
          },
          {
            id: 2,
            title: '“首都教育远程互助工程——和田项目”汇报暨启动会',
            time: '2021年10月18日',
            type: '新闻资讯'
          }, {
            id: 3,
            title: '“首都教育远程互助工程——和田项目”汇报暨启动会',
            time: '2021年10月18日',
            type: '新闻资讯'
          },
          {
            id: 4,
            title: '“首都教育远程互助工程——和田项目”汇报暨启动会',
            time: '2021年10月18日',
            type: '新闻资讯'
          },
          {
            id: 5,
            title: '“首都教育远程互助工程——和田项目”汇报暨启动会',
            time: '2021年10月18日',
            type: '新闻资讯'
          },
          {
            id: 6,
            title: '“首都教育远程互助工程——和田项目”汇报暨启动会',
            time: '2021年10月18日',
            type: '新闻资讯'
          }, {
            id: 7,
            title: '“首都教育远程互助工程——和田项目”汇报暨启动会',
            time: '2021年10月18日',
            type: '新闻资讯'
          }
        ],

      }
    },
    methods: {
      async getTealist() {
        let param = {
          type: 1,
          isAsc: 'desc'
        }
        let resData = await Api.NewHome.gettealist(param)
        // console.log(resData)
        for (let index = 0; index < resData.rows.length; index += 3) {
          this.expertList.push(resData.rows.slice(index, index + 3));
        }
        // console.log(this.expertList);
        this.pages.total = resData.total
      },
    },
    mounted() {
      this.getTealist();
    },
  }
</script>

<style lang="less" scoped>
  .case {
    .banner {
      width: 100%;
    }

    .case-wrapper {
      margin: 56px auto;
      width: 1200px;

      .departmental-list {
        width: 1200px;
        margin: 44px auto 82px;
      }

      .departmental-title {
        text-align: center;
        padding: 52px 0 97px;
        margin-bottom: 40px;
      }

      .departmental-title>span {
        padding: 52px 12px 97px;
        font-size: 32px;
        color: #383838;
      }

      .departmental-title::after {
        content: ' ';
        position: relative;
        z-index: 2;
        display: block;
        margin: 0 auto;
        width: 518px;
        height: 28px;
        top: 32px;
        background-image: url("../assets/common/title-bottom.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .project {
        margin-bottom: 58px;

        .project-discribe {
          font-size: 16px;
          color: #666;
          line-height: 30px;
        }

        .project-ul {
          margin-top: 60px;
        }

        .project-li {
          box-sizing: border-box;
          display: inline-block;
          width: 341px;
          padding: 0 16px;
          box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
          position: relative;

          &::before {
            content: ' ';
            position: absolute;
            height: 5px;
            width: calc(100% - 6px);
            top: -6px;
            left: 3px;
            background-color: #3370FF;
          }
        }

        .project-li-title {
          border-bottom: 1px solid rgba(220, 220, 220, .37);
          font-size: 22px;
          font-weight: bold;
          padding: 32px 0 10px 0;

          &>img {
            margin: 0 32px 0 10px;
          }
        }

        .project-li-introduce {
          font-size: 14px;
          color: #666;
          line-height: 22px;
          height: 123px;
        }

      }

      .news {
        .news-ul {
          margin-bottom: 60px;
        }

        .news-li {
          box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
          border-radius: 10px;
          display: inline-block;
          width: calc((100% / 4) - 19px);
          margin-right: 25px;
          margin-bottom: 21px;
          overflow: hidden;
          position: relative;

          &:nth-child(3),
          &:nth-child(7) {
            margin-right: 0;
          }

          &.new-li-one {
            width: calc(((100% / 4) - 6px)*2);
            vertical-align: bottom;

            .news-li-type {
              position: static;
              margin-bottom: 15px;
              display: inline-block;
            }

            .news-li-img {
              width: 100%;
              height: 295px;
            }

            .news-li-one-cover {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(7, 147, 239, .9);
              padding: 50px 80px 0 50px;
              box-sizing: border-box;
            }

            .news-li-title,
            .news-li-time {
              font-size: 27px;
              color: #fff;
              line-height: 42px;
            }

            .news-li-time {
              font-size: 18px;
              line-height: 18px;
              margin-top: 39px;
            }
          }
        }

        .news-li-type {
          border-radius: 25px;
          border: 1px solid #fff;
          padding: 0 22px;
          line-height: 31px;
          font-size: 18px;
          position: absolute;
          top: 19px;
          left: 23px;
          color: #fff;
        }

        .news-li-img {
          width: 100%;
          height: 166px;

        }

        .news-li-info {
          padding: 12px 20px 27px;
        }

        .news-li-title {
          color: #535353;
          font-size: 18px;
          font-weight: 500;
          line-height: 30px;
        }

        .news-li-time {
          font-size: 16px;
          color: #9B9BA3;
          margin-top: 12px;
        }



      }

      .expert {
        .expert-inner {

          /deep/ .el-carousel__arrow--left,
          /deep/ .el-carousel__arrow--right {
            background-color: transparent;
            border: 1px solid #666;
            width: 35px;
            height: 35px;


            .el-icon-arrow-left,
            .el-icon-arrow-right {
              color: #666;
              font-size: 18px;
            }
          }

          /deep/ .el-carousel__item {
            padding: 70px 0;
            height: auto;
          }

          .expert-carousel {
            /deep/ .el-carousel__container {
              height: 500px;
            }
          }

          .expert-ul {
            padding: 0 150px;
          }

          .expert-item {
            width: 242px;
            height: 341px;
            text-align: center;
            cursor: pointer;



            .expert-item-inner {
              transition: 1s all ease;
              width: 241px;
              margin: 0 auto;
              box-shadow: 0px 2px 15px 0px rgba(60, 108, 195, 0.19);
              overflow: hidden;
            }

            &:hover .expert-item-inner {
              transform: scale(1.2);
            }

            .expert-avatar {
              width: 100%;
              height: 225px;
            }

            .expert-item-info {
              padding: 8px 16px 16px 16px;
            }

            .expert-name {
              font-size: 18px;
              font-weight: 400;
              margin-bottom: 8px;

              &::after {
                content: " ";
                display: block;
                margin: 0 auto;
                width: 91px;
                height: 1px;
                background-color: #f4f4f4;
                margin-top: 8px;
              }
            }

            .expert-introduce {
              font-size: 14px;
              font-weight: 400;
              color: #999999;
              line-height: 22px;
              text-align: left;
            }
          }
        }
      }
    }

    @media screen and(max-width:1250px) {
      .case-wrapper {
        margin: 46px auto;
        width: 990px;

        .departmental-list {
          width: 990px;
          margin: 36px auto 68px;
        }

        .departmental-title {
          padding: 43px 0 80px;
          margin-bottom: 33px;
        }

        .departmental-title>span {
          padding: 43px 5px 80px;
        }

        .departmental-title::after {
          width: 427px;
          height: 23px;
          top: 26px;
        }

        .project {
          margin-bottom: 48px;

          .project-discribe {
            font-size: 13px;
            line-height: 25px;
          }

          .project-ul {
            margin-top: 53px;
          }

          .project-li {
            width: 282px;
            padding: 0 13px;

            &::before {
              height: 4px;
              width: calc(100% - 4px);
              top: -5px;
              left: 2px;
            }
          }

          .project-li-title {
            font-size: 18px;
            padding: 19px 0 8px 0;

            &>img {
              margin: 0 26px 0 8px;
            }
          }

          .project-li-introduce {
            font-size: 12px;
            line-height: 18px;
            height: 102px;
          }

        }

        .news {
          .news-ul {
            margin-bottom: 60px;
          }

          .news-li {
            border-radius: 8px;
            width: calc((100% / 4) - 16px);
            margin-right: 21px;
            margin-bottom: 16px;

            &.new-li-one {
              width: calc(((100% / 4) - 6px)*2);
              vertical-align: bottom;

              .news-li-type {
                margin-bottom: 15px;
              }

              .news-li-img {
                height: 241px;
              }

              .news-li-one-cover {
                padding: 45px 60px 0 45px;
                box-sizing: border-box;
              }

              .news-li-title,
              .news-li-time {
                font-size: 22px;
                line-height: 35px;
              }

              .news-li-time {
                font-size: 15px;
                line-height: 15px;
                margin-top: 26px;
              }
            }
          }

          .news-li-type {
            padding: 0 18px;
            line-height: 26px;
            font-size: 15px;
            top: 16px;
            left: 20px;
          }

          .news-li-img {
            width: 100%;
            height: 138px;

          }

          .news-li-info {
            padding: 8px 17px 22px;
          }

          .news-li-title {
            font-size: 15px;
            line-height: 25px;
          }

          .news-li-time {
            font-size: 13px;
            margin-top: 8px;
          }



        }

        .expert {
          .expert-inner {

            /deep/ .el-carousel__arrow--left,
            /deep/ .el-carousel__arrow--right {
              width: 28px;
              height: 28px;

              .el-icon-arrow-left,
              .el-icon-arrow-right {
                font-size: 16px;
              }
            }

            /deep/ .el-carousel__item {
              padding: 50px 0;
            }

            .expert-carousel {
              /deep/ .el-carousel__container {
                height: 450px;
              }
            }

            .expert-ul {
              padding: 0 100px;
            }

            .expert-item {
              width: 242px;
              height: 341px;



              .expert-item-inner {
                width: 200px;
              }

              .expert-avatar {
                height: 187px;
              }

              .expert-item-info {
                padding: 5px 14px 14px 14px;
              }

              .expert-name {
                font-size: 15px;
              }

              .expert-introduce {
                font-size: 12px;
                line-height: 18px;
              }
            }
          }
        }
      }

    }
  }
</style>